import React from 'react'
import {Progress, Modal, Button} from 'antd'
import {useState} from 'react'
import {useEffect} from 'react'
import {ObsKeyToURL} from 'api/utils'
import './downloadFile.less'

interface Props {
  name: string
  suffix: string
  url: string
  downloading: boolean
  setDownloading: (finish: boolean) => void
}

export const DownloadFileModal: React.FC<Props> = ({
  name,
  suffix,
  url,
  downloading,
  setDownloading,
}) => {
  const [downloadProgress, setDownloadProgress] = useState(0)
  const [loaded, setLoaded] = useState(0)
  const [total, setTotal] = useState(0)

 
  const [xhr,setXHR] = useState(new XMLHttpRequest())


  useEffect(() => {
    if (downloading) {
      console.log(ObsKeyToURL(url), url)

      xhr.open('get', ObsKeyToURL(url))
      xhr.responseType = 'blob'
      xhr.onprogress = function (e) {
        console.log(e)

        if (e.lengthComputable) {
          let loaded = Math.round(e.loaded / (1024 * 1024))
          let total = Math.round(e.total / (1024 * 1024))
          console.log(loaded, total)

          setLoaded(loaded)
          setTotal(total)
          if (total !== 0) {
            setDownloadProgress(Math.round((loaded / total) * 100))
          }
        }
      }
      // 下载完成
      xhr.onload = function (e) {
        console.log('onload', e)

        setDownloading(false)
        setLoaded(0)
        setTotal(0)
        let u = window.URL.createObjectURL(xhr.response)
        let a = document.createElement('a')
        a.href = u
        a.download = `${name}.${suffix}`
        a.click()
      }
      xhr.send()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloading])

  const closeDownloadModal = () => {
    xhr.abort()
    setDownloading(false)
    setLoaded(0)
    setTotal(0)
  }

  return (
    <>
      <Modal width={584} className="download-modal" footer={null} visible={downloading} centered>
        <div className="title download-modal-title">下载中...</div>
        <div className="small download-modal-file-name">
          {name}.{suffix}
        </div>
        <Progress
          percent={downloadProgress}
          format={() => `${loaded}M/${total}M`}
          className="download-progress-content"
        ></Progress>
        <div className="download-modal-close-button-outer">
          <Button type="text" className="download-modal-close-button" onClick={closeDownloadModal}>
            取消下载
          </Button>
        </div>
      </Modal>
    </>
  )
}
